import React, { useEffect, useReducer, useContext, createContext } from 'react';
import { Entry } from 'contentful';
import { Spin } from 'antd';
import Page404 from 'pages/404';
import Content from './Content';
import { ContentPageType } from 'types/Content';
import { SlugMatch } from 'types/Route';
import { requestGetContentPage, ContentPageActionType } from './actions';
import reducer, { ContentPageState } from './reducer';

export default function ContentPage({ match }: { match: SlugMatch }) {
  const [{ loading, entry, pageNotFound }, dispatch] = useReducer(
    reducer,
    useContext(
      createContext({
        loading: false,
        entry: undefined,
        pageNotFound: false
      })
    )
  ) as [
    ContentPageState,
    React.Dispatch<{
      type: ContentPageActionType;
      payload: { entry: Entry<ContentPageType> } | null;
    }>
  ];

  useEffect(() => {
    if (match.params.slug) {
      requestGetContentPage(match.params.slug, dispatch);
    } else if (match.url) {
      requestGetContentPage(match.url.split('/')[1], dispatch);
    }
  }, [match, dispatch]);

  return (
    <>
      {loading ? (
        <Spin />
      ) : pageNotFound ? (
        <Page404 />
      ) : (
        entry && <Content entry={entry} />
      )}
    </>
  );
}
